import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

// Convierte una respuesta de error en un Error con `code` y, si el servidor la manda, la explicación legible.
async function failure(response, fallback) {
  const data = await response.json().catch(() => ({}))
  const error = new Error(data.message || fallback)
  error.code = data.error
  return error
}

export async function saveOnboardingPlots(parkId, rows) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/onboarding/plots`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ rows }),
  })
  if (!response.ok) throw await failure(response, 'No se pudieron registrar las naves')
  return response.json()
}

export async function completeOnboarding(parkId, skipped = false) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/onboarding/complete`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ skipped }),
  })
  if (!response.ok) throw await failure(response, 'No se pudo terminar la configuración')
  return response.json()
}

export async function dismissWhatsappSuggestion(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/onboarding/dismiss-whatsapp`, { method: 'POST' })
  if (!response.ok) throw await failure(response, 'No se pudo descartar la sugerencia')
  return response.json()
}